import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import toast from 'react-hot-toast';
import styles from './SubscribeForm.module.css';

export default function SubscribeForm() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.includes('@')) return;
    setLoading(true);
    try {
      await api.post('/subscribers', { email });
      setDone(true);
      toast.success(t('subscribe.success'));
    } catch {
      toast.error('Subscription failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('subscribe.title')}</h2>
      <p className={styles.subtitle}>{t('subscribe.subtitle')}</p>
      {done ? (
        <p className={styles.success}>{t('subscribe.success')} ✓</p>
      ) : (
        <form className={styles.form} onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder={t('subscribe.placeholder')}
            className={styles.input}
            required
          />
          <button type="submit" className={styles.btn} disabled={loading}>
            {loading ? '...' : t('subscribe.button')}
          </button>
        </form>
      )}
    </div>
  );
}
